import React from "react";
import { format } from "date-fns";

interface EvidenceDateProps {
  date?: string;
  label?: string;
}

const EvidenceDate: React.FC<EvidenceDateProps> = ({ date, label = "Date" }) => {
  if (!date) return null;

  return (
    <div className="readEvidenceBlock">
      <div className="readEvidenceHeader">{label}</div>
      <div className="readEvidenceText">{format(new Date(date), "d MMMM yyyy")}</div>
      <div className="h-[1px] w-full bg-grey-30 mt-4" />
    </div>
  );
};

export default EvidenceDate;
